export function ErrorScreen() {
  return (
    <div className={'h-screen flex flex-col justify-center bg-'}>
      <div className={'my-auto flex flex-col gap-12 p-6 text-center'}>
        error
      </div>
    </div>
  );
}
